var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.442 -253.91)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 448.06 409.3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1631.3-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.3871)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1615.1-569.77q1.709-0.0684 2.4382-0.91146 0.7291-0.86588 0.7291-2.6432v-2.1419q0-1.8685-0.8203-2.7344-0.8203-0.86589-2.666-0.86589h-8.4994q-1.8457 0-2.666 0.86589-0.8203 0.86588-0.8203 2.7344v2.1419q0 1.7774 0.7292 2.6432 0.7519 0.8431 2.4381 0.91146zm0.1367 14.219q1.8685 0 2.6888-0.86589 0.8203-0.86588 0.8203-2.7116v-2.5293q0-1.8685-0.8203-2.7116t-2.6888-0.8431h-9.4108q-1.8685 0-2.6888 0.8431t-0.8203 2.7116v2.5293q0 1.8457 0.8203 2.7116 0.8203 0.86589 2.6888 0.86589zm-9.5475 4.5801q-7.9525 0-7.9525-7.9297v-1.6406q0-3.0534 1.0938-4.8991 1.0937-1.8457 3.1673-2.4609-1.8457-0.86589-2.8255-2.6432-0.9571-1.8001-0.9571-4.5573v-0.59245q0-7.9525 7.9297-7.9525h8.7728q7.9297 0 7.9297 7.9525v0.59245q0 2.7572-0.9798 4.5573-0.957 1.7773-2.8027 2.6432 2.0735 0.61523 3.1673 2.4609 1.0937 1.8457 1.0937 4.8991v1.6406q0 7.9297-7.9297 7.9297z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.0c39a28f65ea93bbe809304358e9afb5.svg";
export { ForwardRef as ReactComponent };